/* eslint-disable no-restricted-syntax */
import clsx, { ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/*
 * `bg-select-arrow` is this project's own `backgroundImage` key (tailwind.config.js), and
 * tailwind-merge only knows the classes Tailwind ships. Unregistered, it read `bg-select-arrow` as a
 * background *colour* and dropped it as a conflict with `bg-white` — which is how every legacy
 * `ui/Select` silently lost its chevron the moment its class list went through `cn` instead of
 * `clsx`. Registering it in the `bg-image` group is what makes the two coexist.
 *
 * Any future custom key under a `theme.extend` group Tailwind also ships needs the same treatment.
 */
const twMerge = extendTailwindMerge({
  extend: { classGroups: { "bg-image": ["bg-select-arrow"] } },
});

/**
 * Utility function that merges classes, but makes sure that tailwind classes are correctly replaced.
 *
 * @param args
 */
export const cn = (...args: ClassValue[]) => {
  return twMerge(clsx(args));
};
